function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlannedItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 1V3.5M11 1V3.5M6.52197 14.75H3.5C2.11931 14.75 1 13.6307 1 12.25V4.75C1 3.36922 2.11931 2.25 3.5 2.25H12.25C13.6307 2.25 14.75 3.36922 14.75 4.75V6H1",
    stroke: "#828282",
    style: {
      stroke: "#828282",
      stroke: "color(display-p3 0.5083 0.5083 0.5083)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z",
    stroke: "#828282",
    style: {
      stroke: "#828282",
      stroke: "color(display-p3 0.5083 0.5083 0.5083)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.75V12H13.25",
    stroke: "#828282",
    style: {
      stroke: "#828282",
      stroke: "color(display-p3 0.5083 0.5083 0.5083)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlannedItems);
export default __webpack_public_path__ + "static/media/plannedItems.6a1d3eee01a37164615668f6d6043a7c.svg";
export { ForwardRef as ReactComponent };